import React from 'react';
import { Stack, Panel } from 'rsuite';
import './Commen.css'

const Copyright = () => {
  return (
    
    // <div className='tophead '>
      
    // <Panel className='headh' header={<p className="title title2" style={{'background':'#fff','position':'fixed','width':'100%', 'borderRadius':'8px','bottom':'0', 'textAlign':'center'}}> 
    // {/* <Whisper placement="bottomEnd" trigger="click" ref={trigger} speaker={renderAdminSpeaker}>
    //   <GearIcon  style={{ fontSize: '1em', 'marginLeft': '85%'}} />
    //   </Whisper> */}
    //   {/* <h5><b> {ctime} </b></h5> */}
      
    //   <div style={{'justifyContent':'space-between','display':'flex'}}>
        
    //   <div className='time'><p>© All Right Reserved. Product by </p></div>
    //   <div className='headersecond' style={{'marginRight':' 15px'}}>
      
    //   <p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p>
      
    //   </div></div></p>}>
    
    // </Panel>
    // </div>
    
    <Stack className="copyright" justifyContent="space-between" style={{'backgroundColor':'#fff','position':'absolute','width':'-webkit-fill-available','bottom':'0','marginLeft':'-35px','paddingRight':'14px'}}>
      <div className="container">
      <p>© All Right Reserved. Product by </p></div><div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        {/* <p>
          © 2022, Made with ❤️ by{' '}
          <a href="https://github.com/rsuite/rsuite" target="_blank" rel="noreferrer">
            RSUITE
          </a>
        </p> */}
      
    </Stack>
  );
};

export default Copyright;
